import { mapState } from 'vuex';
export default {
  props: {
    info: Object,
    rtilCodeList: Array,
    pageNumber: Number
  },
  data() {
    return {
      activeVal: '',
      visible: false,
      currentPageList: [],
      alternateList: [],
      current: {},
      activeName: 'Seated',
      btnText: 'Ok',
      nickName: {},
      tagName: {}
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      PrivateInfo: state => state.privateInfo
    }),
    tipText() {
      let _str = this.$t('galleryHost.replaceOne');
      if (this.activeName != 'Seated') {
        _str = this.$t('galleryHost.replaceTwo');
      }
      return _str;
    },
    showOkClass() {
      let _class = '';
      if (this.activeName === 'Seated') {
        if (!this.currentPageList.length) {
          _class = 'ok';
          this.btnText = this.$t('galleryHost.ok');
        } else {
          this.btnText = this.$t('galleryHost.cancel');
        }
      } else {
        if (!this.alternateList.length) {
          _class = 'ok';
          this.btnText = this.$t('galleryHost.ok');
        } else {
          this.btnText = this.$t('galleryHost.cancel');
        }
      }
      return _class;
    }
  },
  created() {
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.nickName, val.mark, val.value);
        }
        if (val.key === 'tagName') {
          this.$set(this.tagName, val.mark, val.value);
        }
      });
    });
    this.getCurrentPageUser();
    this.axios.get(`/partyline-backend/group/alternateList/${this.info.groupId}`).then(res => {
      if (res.data.errorCode === '0x0') {
        this.alternateList = res.data.result || [];
        this.alternateList = this.alternateList.filter(v => {
          return v.rtilCode != this.info.originRtilCode && !this.rtilCodeList.includes(v.rtilCode);
        });
      }
    });
  },
  methods: {
    getCurrentPageUser() {
      this.axios.get(`/partyline-backend/group/currentPageUser?groupId=${this.info.groupId}&pageNum=${this.pageNumber}`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.currentPageList = res.data.result || [];
          this.currentPageList = this.currentPageList.filter(v => {
            return v.rtilCode != this.info.originRtilCode;
          });
          // 如果在私聊状态则不能 replace
          if (JSON.stringify(this.PrivateInfo) != '{}' && this.PrivateInfo.rtilCode == this.info.originRtilCode) {
            this.currentPageList = [];
          }
        }
      });
    },
    showTips() {
      if (!this.activeVal) return;
      // 判断当前要替换的人是否为Publick speaker
      if (this.State.gallerySpeakerInfo && this.State.gallerySpeakerInfo.rtilCode == this.activeVal) {
        this.$message({
          type: 'warning',
          message: this.$t('addWords.notSelectCurrentSource')
        });
        return;
      }
      this.visible = !this.visible;
    },
    close() {
      this.info.show = false;
      this.visible = false;
      this.nickName = {};
      this.tagName = {};
    },
    select(val) {
      this.current = val;
      this.activeVal = val.rtilCode;
    },
    save(val) {
      if (!this.activeVal) {
        this.$message.warning(this.$t('galleryHost.noReplace'));
        return;
      }
      const indexIsNaN = isNaN(this.info.index);
      let params;
      if (indexIsNaN) {
        params = {
          partyCode: this.info.groupId,
          module: 'replaceParticipant',
          msg: {
            originRtil: this.info.originRtilCode,
            targetRtil: this.activeVal,
            originRealPartyCode: this.info.originRealPartyCode,
            targetRealPartCode: this.current.partyCode
          }
        };
      } else {
        let index;
        // 根据当前的发送页数去计算空白位置的index
        if (this.info.pageNum > 1) {
          index = (this.info.pageNum - 1) * (this.State.groupLayout.layout * this.State.groupLayout.column) + this.info.index;
        } else {
          index = this.info.index;
        }
        params = {
          partyCode: this.info.groupId,
          module: 'replaceParticipant',
          msg: {
            originRtil: this.activeVal,
            originRealPartyCode: this.current.partyCode,
            targetIndex: index
          }
        };
      }
      this.State.originRtil = this.info.originRtilCode;
      this.State.targetRtil = this.activeVal;
      this.axios.post('/partyline-backend/party/noLogin/command?key=34130', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('galleryHost.replaceSuccessful'));
          this.close();
        }
        if (this.info.originRealPartyCode == this.current.partyCode) {
          // 通知推送newRtilcode
          this.axios.get(`/partyline-backend/group/pushNewRtilCodes/${this.info.groupId}`).then(res => {});
        }
      });
    }
  }
};